@if (isOpen()) {
  <div
    class="erro-overlay"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    [attr.aria-describedby]="detailId"
    (click)="close()"
    (keydown)="onOverlayKeydown($event)"
  >
    <div class="erro-dialog" (click)="$event.stopPropagation()">
      <h2 class="erro-dialog__title" [id]="titleId">{{ title() }}</h2>
      <p class="erro-dialog__detail" [id]="detailId">{{ detail() }}</p>

      @if (fieldErrors().length > 0) {
        <ul class="erro-dialog__field-errors">
          @for (fe of fieldErrors(); track fe.field + fe.message) {
            <li>
              @if (fe.field) {
                <strong>{{ fe.field }}:</strong>
              }
              {{ fe.message }}
            </li>
          }
        </ul>
      }

      @if (traceId()) {
        <div class="erro-dialog__trace">
          <span class="erro-dialog__trace-label">ID do erro:</span>
          <code class="erro-dialog__trace-id">{{ traceId() }}</code>
          <button
            type="button"
            class="erro-dialog__trace-copy"
            (click)="copyTrace()"
            aria-label="Copiar ID do erro"
          >
            {{ copyState() === 'copied' ? 'Copiado' : 'Copiar' }}
          </button>
        </div>
      }

      <div class="erro-dialog__acoes">
        <button
          #closeBtn
          type="button"
          class="erro-dialog__btn erro-dialog__btn--confirmar"
          (click)="close()"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
}
